import { MediaTypeParser } from '@internetarchive/field-parsers';
import { MetadataField } from '../metadata-field';
export class MediaTypeField extends MetadataField {
    constructor(rawValue) {
        super(MediaTypeParser.shared, rawValue);
    }
}
//# sourceMappingURL=mediatype.js.map